var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-field',{attrs:{"attribute":_vm.attribute,"type":_vm.type,"label":_vm.label,"required":_vm.required,"errorKeys":_vm.errorKeys}},[_c('input',{attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.update}})])}
var staticRenderFns = []

export { render, staticRenderFns }